import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Retrieves the asset for a given card network. Returns a promise that resolves to the asset object.`}</p>
    <Group summary='Parameters' mdxType="Group">
      <Item title='cardNetwork' subtitle='string' mdxType="Item">
        <p>{`The network value, for example: `}<inlineCode parentName="p">{`VISA`}</inlineCode>{`, `}<inlineCode parentName="p">{`MASTERCARD`}</inlineCode>{`.`}</p>
      </Item>
    </Group>
    <Group summary='Returns' mdxType="Group">
      <Item title='cardUrl' subtitle='string' mdxType="Item">
The URL for retrieving the asset in a "card" style.
      </Item>
      <Item title='displayName' subtitle='string' mdxType="Item">
        <p>{`The name of the card network.`}<br parentName="p"></br>{`
`}{`Can be used as `}<a parentName="p" {...{
            "href": "https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/alt"
          }}>{`alt`}</a>{`
and `}<a parentName="p" {...{
            "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/title"
          }}>{`title`}</a>{` for the image.`}</p>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      